// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles__pullRight___iiupl {
  text-align: right;
}
@media (max-width: 991px) {
  .styles__pullRight___iiupl {
    display: flex;
    justify-content: space-between;
    padding-top: 10px;
    padding-bottom: 10px;
  }
}
.styles__logo___DnHbI {
  display: flex;
  justify-content: center;
}
@media (max-width: 991px) {
  .styles__logo___DnHbI {
    justify-content: flex-start;
  }
}
.styles__header___EwRjk {
  color: #fff;
}
.styles__fullWidth___nE55r {
  width: 100%;
}
@media (min-width: 992px) {
  .styles__sidebar___IIb69 {
    display: none;
  }
}
@media (max-width: 991px) {
  .styles__headerContainer___JX3Yq {
    order: 1;
  }
}
@media (max-width: 991px) {
  .styles__phoneNumber___DNvJ_ {
    padding: 1em 0 0 0;
    order: 2;
  }
}
@media (max-width: 991px) {
  .styles__sidebarContainer___NgF83 {
    order: 3;
  }
}
.styles__phoneIcon___lM101 {
  margin-right: 10px;
}
.styles__wrapperHeader___C8AEI {
  padding-top: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 10px;
  color: #fff;
  max-width: 1140px;
  margin: auto !important;
  flex-direction: row;
}
@media (max-width: 991px) {
  .styles__wrapperHeader___C8AEI {
    flex-direction: column;
  }
}
.styles__nav___gx2lU {
  display: flex;
  flex-direction: row;
}
.styles__navLeft___XWoml {
  float: left;
  padding-left: 15px;
}
@media (max-width: 991px) {
  .styles__navLeft___XWoml {
    float: none;
    justify-content: space-between;
    margin-bottom: 0 !important;
    padding-left: 0;
  }
}
.styles__menuContainer___rPNOk {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  max-width: 100%;
}
.styles__scrollMenu___h2lvO {
  position: relative;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  -ms-overflow-style: none;
  padding: 0;
  margin-bottom: 0 !important;
  gap: 10px;
  width: 100%;
  height: 100%;
  scroll-behavior: smooth;
}
.styles__scrollMenu___h2lvO::-webkit-scrollbar {
  display: none;
}
.styles__navArrow___wWtbT {
  position: absolute;
  z-index: 10;
  height: 100%;
  width: 40px;
  background: rgba(255, 255, 255, 0.8);
  border: none !important;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.3s;
  font-size: 30px;
}
.styles__navArrow___wWtbT .styles__arrow___oHZKO {
  filter: drop-shadow(1px 1px 3px #666);
}
.styles__navArrowLeft___vK2p_:hover {
  background: linear-gradient(to right, rgba(255, 255, 255, 0.65), rgba(255, 255, 255, 0));
}
.styles__navArrowRight___i9J6o:hover {
  background: linear-gradient(to left, rgba(255, 255, 255, 0.65), rgba(255, 255, 255, 0));
}
.styles__navArrowLeft___vK2p_ {
  left: 0;
  background: linear-gradient(to right, rgba(255, 255, 255, 0.45), rgba(255, 255, 255, 0));
}
.styles__navArrowLeft___vK2p_ .styles__arrow___oHZKO {
  margin-left: -10px;
}
.styles__navArrowRight___i9J6o {
  right: 0;
  background: linear-gradient(to left, rgba(255, 255, 255, 0.45), rgba(255, 255, 255, 0));
}
.styles__navArrowRight___i9J6o .styles__arrow___oHZKO {
  margin-right: -10px;
}
@media (max-width: 991px) {
  .styles__navArrow___wWtbT {
    height: 100%;
    width: 30px;
  }
}
.styles__navRight___aI42O {
  float: right;
  padding-right: 15px;
  height: 100%;
}
@media (min-width: 768px) {
  .styles__navRight___aI42O {
    margin-right: 0px;
  }
}
@media (max-width: 991px) {
  .styles__navRight___aI42O {
    display: none;
  }
}
.styles__logotypeImage___dkXIH {
  display: inline-block;
}
.styles__logotypeImage___dkXIH > img {
  max-width: 700px;
  max-height: 70px;
  width: 100%;
}
@media (max-width: 991px) {
  .styles__logotypeImage___dkXIH {
    margin-right: auto;
  }
}
@media (max-width: 767px) {
  .styles__logotypeImage___dkXIH {
    margin: 20px 0 0;
  }
}
.styles__flexSpaceBetween___FZw91 {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
@media (max-width: 991px) {
  .styles__flexSpaceBetween___FZw91 {
    align-items: flex-start;
    justify-content: flex-start;
  }
}
.styles__headlessHeader___OyXkN {
  padding-top: 32px;
}
.styles__headlessCart___EqdON {
  display: flex;
  align-items: center;
  height: 57px;
}
.styles__headerNavbar___ByytC {
  height: 56px;
}
.styles__navbarContainer___n_LVA {
  height: 100%;
  padding: 0 !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/components/Header/styles.less"],"names":[],"mappings":"AAEA;EACE,iBAAA;AADF;AAEE;EAAA;IACE,aAAA;IACA,8BAAA;IACA,iBAAA;IACA,oBAAA;EACF;AACF;AAEA;EACE,aAAA;EACA,uBAAA;AAAF;AACE;EAAA;IACE,2BAAA;EAEF;AACF;AACA;EACE,WAAA;AACF;AAEA;EACE,WAAA;AAAF;AAIE;EAAA;IACE,aAAA;EADF;AACF;AAKE;EAAA;IACE,QAAA;EAFF;AACF;AAME;EAAA;IACE,kBAAA;IACA,QAAA;EAHF;AACF;AAOE;EAAA;IACE,QAAA;EAJF;AACF;AAOA;EACE,kBAAA;AALF;AAQA;EACE,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,oBAAA;EACA,WAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;AANF;AAOE;EAAA;IACE,sBAAA;EAJF;AACF;AAOA;EACE,aAAA;EACA,mBAAA;AALF;AAQA;EAEE,WAAA;EACA,kBAAA;AANF;AAOE;EAAA;IACE,WAAA;IACA,8BAAA;IACA,2BAAA;IACA,eAAA;EAJF;AACF;AAOA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;AALF;AAQA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,iCAAA;EACA,qBAAA;EACA,wBAAA;EACA,UAAA;EACA,2BAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;AANF;AASA;EACE,aAAA;AAPF;AAUA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,oCAAA;EACA,uBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,iCAAA;EACA,eAAA;AARF;AAWA;EAEI,qCAAA;AAVJ;AAcA;EACE,wFAAA;AAZF;AAeA;EACE,uFAAA;AAbF;AAgBA;EACE,OAAA;EACA,wFAAA;AAdF;AAYA;EAII,kBAAA;AAbJ;AAiBA;EACE,QAAA;EACA,uFAAA;AAfF;AAaA;EAII,mBAAA;AAdJ;AAkBA;EACE;IACE,YAAA;IACA,WAAA;EAhBF;AACF;AAmBA;EAEE,YAAA;EACA,mBAAA;EACA,YAAA;AAjBF;AAkBE;EAAA;IACE,iBAAA;EAfF;AACF;AAiBE;EAAA;IACE,aAAA;EAdF;AACF;AAiBA;EAME,qBAAA;AApBF;AAcA;EAEI,gBAAA;EACA,gBAAA;EACA,WAAA;AAbJ;AAgBE;EAAA;IACE,kBAAA;EAbF;AACF;AAcE;EAAA;IACE,gBAAA;EAXF;AACF;AAeA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AAbF;AAcE;EAAA;IACE,uBAAA;IACA,2BAAA;EAXF;AACF;AAcA;EACE,iBAAA;AAZF;AAeA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;AAbF;AAgBA;EACE,YAAA;AAdF;AAkBA;EACE,YAAA;EACA,qBAAA;AAhBF","sourcesContent":["@import '../../../shared/variables.less';\n\n.pullRight {\n  text-align: right;\n  @media (max-width: @screen-sm-max) {\n    display: flex;\n    justify-content: space-between;\n    padding-top: 10px;\n    padding-bottom: 10px;\n  }\n}\n\n.logo {\n  display: flex;\n  justify-content: center;\n  @media (max-width: @screen-sm-max) {\n    justify-content: flex-start;\n  }\n}\n\n.header {\n  color: @eon-header-text-color;\n}\n\n.fullWidth {\n  width: 100%\n}\n\n.sidebar {\n  @media (min-width: @screen-md-min) {\n    display: none;\n  }\n}\n\n.headerContainer {\n  @media (max-width: @screen-sm-max) {\n    order: 1;\n  }\n}\n\n.phoneNumber {\n  @media (max-width: @screen-sm-max) {\n    padding: 1em 0 0 0;\n    order: 2;\n  }\n}\n\n.sidebarContainer {\n  @media (max-width: @screen-sm-max) {\n    order: 3;\n  }\n}\n\n.phoneIcon {\n  margin-right: 10px;\n}\n\n.wrapperHeader {\n  padding-top: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding-bottom: 10px;\n  color: @eon-header-text-color;\n  max-width: 1140px;\n  margin: auto !important;\n  flex-direction: row;\n  @media (max-width: @screen-sm-max) {\n    flex-direction: column;\n  }\n}\n\n.nav {\n  display: flex;\n  flex-direction: row;\n}\n\n.navLeft {\n  composes: nav;\n  float: left;\n  padding-left: 15px;\n  @media (max-width: @screen-sm-max) {\n    float: none;\n    justify-content: space-between;\n    margin-bottom: 0 !important;\n    padding-left: 0;\n  }\n}\n\n.menuContainer {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n  max-width: 100%;\n}\n\n.scrollMenu {\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n  padding: 0;\n  margin-bottom: 0 !important;\n  gap: 10px;\n  width: 100%;\n  height: 100%;\n  scroll-behavior: smooth;\n}\n\n.scrollMenu::-webkit-scrollbar {\n  display: none;\n}\n\n.navArrow {\n  position: absolute;\n  z-index: 10;\n  height: 100%;\n  width: 40px;\n  background: rgba(255, 255, 255, 0.8);\n  border: none !important;\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: background-color 0.3s;\n  font-size: 30px;\n}\n\n.navArrow {\n  .arrow {\n    filter:drop-shadow(1px 1px 3px #666);\n  }\n}\n\n.navArrowLeft:hover {\n  background: linear-gradient(to right, rgba(255,255,255,0.65), rgba(255,255,255,0));\n}\n\n.navArrowRight:hover {\n  background: linear-gradient(to left, rgba(255,255,255,0.65), rgba(255,255,255,0));\n}\n\n.navArrowLeft {\n  left: 0;\n  background: linear-gradient(to right, rgba(255,255,255,0.45), rgba(255,255,255,0));\n  .arrow {\n    margin-left: -10px;\n  }\n}\n\n.navArrowRight {\n  right: 0;\n  background: linear-gradient(to left, rgba(255,255,255,0.45), rgba(255,255,255,0));\n  .arrow {\n    margin-right: -10px;\n  }\n}\n\n@media (max-width: @screen-sm-max) {\n  .navArrow {\n    height: 100%;\n    width: 30px;\n  }\n}\n\n.navRight {\n  composes: nav;\n  float: right;\n  padding-right: 15px;\n  height: 100%;\n  @media (min-width: @screen-sm-min) {\n    margin-right: 0px;\n  }\n\n  @media (max-width: @screen-sm-max) {\n    display: none;\n  }\n}\n\n.logotypeImage {\n  > img {\n    max-width: 700px;\n    max-height: 70px;\n    width: 100%;\n  }\n  display: inline-block;\n  @media (max-width: 991px) {\n    margin-right: auto;\n  }\n  @media (max-width: 767px) {\n    margin: 20px 0 0;\n  }\n\n}\n\n.flexSpaceBetween {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  @media (max-width: @screen-sm-max) {\n    align-items: flex-start;\n    justify-content: flex-start;\n  }\n}\n\n.headlessHeader {\n  padding-top: 32px;\n}\n\n.headlessCart {\n  display: flex;\n  align-items: center;\n  height: 57px;\n}\n\n.headerNavbar {\n  height: 56px;\n}\n\n\n.navbarContainer {\n  height: 100%;\n  padding: 0 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pullRight": `styles__pullRight___iiupl`,
	"logo": `styles__logo___DnHbI`,
	"header": `styles__header___EwRjk`,
	"fullWidth": `styles__fullWidth___nE55r`,
	"sidebar": `styles__sidebar___IIb69`,
	"headerContainer": `styles__headerContainer___JX3Yq`,
	"phoneNumber": `styles__phoneNumber___DNvJ_`,
	"sidebarContainer": `styles__sidebarContainer___NgF83`,
	"phoneIcon": `styles__phoneIcon___lM101`,
	"wrapperHeader": `styles__wrapperHeader___C8AEI`,
	"nav": `styles__nav___gx2lU`,
	"navLeft": `styles__navLeft___XWoml styles__nav___gx2lU`,
	"menuContainer": `styles__menuContainer___rPNOk`,
	"scrollMenu": `styles__scrollMenu___h2lvO`,
	"navArrow": `styles__navArrow___wWtbT`,
	"arrow": `styles__arrow___oHZKO`,
	"navArrowLeft": `styles__navArrowLeft___vK2p_`,
	"navArrowRight": `styles__navArrowRight___i9J6o`,
	"navRight": `styles__navRight___aI42O styles__nav___gx2lU`,
	"logotypeImage": `styles__logotypeImage___dkXIH`,
	"flexSpaceBetween": `styles__flexSpaceBetween___FZw91`,
	"headlessHeader": `styles__headlessHeader___OyXkN`,
	"headlessCart": `styles__headlessCart___EqdON`,
	"headerNavbar": `styles__headerNavbar___ByytC`,
	"navbarContainer": `styles__navbarContainer___n_LVA`
};
export default ___CSS_LOADER_EXPORT___;
